'use client';

import { useEffect, useState } from 'react';

const SECOND_MILLISECONDS = 1000;
const MINUTE_MILLISECONDS = SECOND_MILLISECONDS * 60;
const HOUR_MILLISECONDS = MINUTE_MILLISECONDS * 60;
const DAY_MILLISECONDS = HOUR_MILLISECONDS * 24;

function DateCountdownItem({ value, label }: { value: number; label: string }) {
  return (
    <div className="text-gray-0 flex flex-col justify-center items-center leading-none">
      <span
        className="hc-typography--heading-three mb-2-2"
        data-testid={`${label.toLocaleLowerCase()}-value`}
      >
        {String(value).padStart(2, '0')}
      </span>
      <span className="hc-typography--disclaimer">{label}</span>
    </div>
  );
}

function DateCountdownDivider() {
  return <span className="hc-typography--heading-three mx-8-8">:</span>;
}

export function DateCountdown({ date }: { date: Date }) {
  const [duration, setDuration] = useState(date.getTime() - Date.now());

  useEffect(() => {
    if (duration <= 0) {
      return;
    }

    const timeout = setTimeout(() => {
      setDuration(date.getTime() - Date.now());
    }, SECOND_MILLISECONDS);

    return () => {
      clearTimeout(timeout);
    };
  }, [date, duration, setDuration]);

  let time = duration;

  const days = Math.trunc(time / DAY_MILLISECONDS);
  time = time % DAY_MILLISECONDS;

  const hours = Math.trunc(time / HOUR_MILLISECONDS);
  time = time % HOUR_MILLISECONDS;

  const minutes = Math.trunc(time / MINUTE_MILLISECONDS);
  time = time % MINUTE_MILLISECONDS;

  const seconds = Math.trunc(time / SECOND_MILLISECONDS);

  return (
    <div className="text-gray-0 bg-[#F26A66] rounded-lg flex px-16-16 py-8-12">
      <DateCountdownItem label="Days" value={days} />
      <DateCountdownDivider />
      <DateCountdownItem label="Hours" value={hours} />
      <DateCountdownDivider />
      <DateCountdownItem label="Minutes" value={minutes} />
      <DateCountdownDivider />
      <DateCountdownItem label="Seconds" value={seconds} />
    </div>
  );
}
